import { render, staticRenderFns } from "./ListPaymentRequest.vue?vue&type=template&id=6676fb98&scoped=true"
import script from "./ListPaymentRequest.vue?vue&type=script&lang=ts"
export * from "./ListPaymentRequest.vue?vue&type=script&lang=ts"
import style0 from "./ListPaymentRequest.vue?vue&type=style&index=0&id=6676fb98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6676fb98",
  null
  
)

export default component.exports